import { useState } from "react";
import { db } from '../../services/firebaseConnection';
import { doc, getDoc, updateDoc } from "firebase/firestore";

const ShiftReports = () => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reportId, setReportId] = useState("");

    const shiftReportsOneWeek = async () => {
        try {
            if (!startDate || !endDate || !reportId) {
                alert("Por favor, preencha todos os campos.");
                return;
            }
            
            const reportRef = doc(db, "Reports", reportId); // Busca o documento pelo ID informado
            const reportSnapshot = await getDoc(reportRef);
            
            if (!reportSnapshot.exists()) {
                alert("Nenhum relatório encontrado.");
                return;
            }
            
            const reportData = reportSnapshot.data();
            if (!reportData.report || !Array.isArray(reportData.report)) {
                console.error("Estrutura do relatório inválida.");
                return;
            }
            
            let updatedReports = reportData.report.map((entry) => {
              if (entry.date) {
                  let oldDate = new Date(entry.date);
                  if (!isNaN(oldDate)) {
                      // Converta startDate e endDate para objetos Date
                      let start = new Date(startDate);
                      let end = new Date(endDate);
          
                      // Verifique se oldDate está dentro do intervalo
                      if (oldDate >= start && oldDate <= end) {
                          let newDate = new Date(oldDate);
                          newDate.setDate(oldDate.getDate() + 7); // Adiciona 7 dias
                          console.log(`Atualizando data: ${oldDate.toISOString()} -> ${newDate.toISOString()}`);
                          return { ...entry, date: newDate.toISOString() };
                      }
                  }
              }
              return entry;
          });
            
            await updateDoc(reportRef, { report: updatedReports });
            
            alert("Datas atualizadas com sucesso!");
        } catch (error) {
            console.error("Erro ao atualizar datas: ", error);
        }
    };

    return (
        <div>
            <h2>Atualizar Datas do Relatório</h2>
            <label>Data Inicial:</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <br />
            <label>Data Final:</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            <br />
            <label>ID do Relatório:</label>
            <input type="text" value={reportId} onChange={(e) => setReportId(e.target.value)} />
            <br />
            <button onClick={shiftReportsOneWeek}>Atualizar Datas</button>
        </div>
    );
};

export default ShiftReports;
